"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SondaType = exports.JS_ERROR = exports.WSElementType = exports.WSEventType = void 0;
/**
 * Possible event types allowed for webservices associated events
 */
var WSEventType;
(function (WSEventType) {
    WSEventType["STARTED"] = "Started";
    WSEventType["LOADED"] = "Loaded";
})(WSEventType = exports.WSEventType || (exports.WSEventType = {}));
/**
 * Enum of possible status of a webservice
 */
var WSElementType;
(function (WSElementType) {
    WSElementType["OK"] = "ok";
    WSElementType["ERROR"] = "error";
    WSElementType["ERROR_TIMEOUT"] = "error-timeout";
})(WSElementType = exports.WSElementType || (exports.WSElementType = {}));
exports.JS_ERROR = 'js-error';
var SondaType;
(function (SondaType) {
    SondaType["WS"] = "ws";
    SondaType["EVENT"] = "event";
    SondaType["ERROR_HANDLER"] = "Error-Handler";
    SondaType["EXTERNAL_FLOW"] = "External-Flow";
})(SondaType = exports.SondaType || (exports.SondaType = {}));
//# sourceMappingURL=sonda.js.map